/**
 * Auth utilities for unity/base Vite SPA.
 * Wraps @unity/auth-core and exposes session helpers.
 * ADR-020, E32 T-3902.
 */

export interface SessionUser {
  id: string
  email: string
  name: string
  role: 'owner' | 'admin' | 'dev' | 'support'
}

export interface SessionData {
  user: SessionUser
}

/**
 * Fetch the current session from /api/auth/session.
 * Returns null if unauthenticated or on error.
 */
export async function getSession(): Promise<SessionData | null> {
  try {
    const res = await fetch('/api/auth/session')
    if (!res.ok) return null
    return (await res.json()) as SessionData
  } catch {
    return null
  }
}

/**
 * Log out the current user by calling /api/auth/logout.
 */
export async function logout(): Promise<void> {
  await fetch('/api/auth/logout', { method: 'POST' })
}
